<!-- rendering from templates -->
<div class="panel-content" [innerHtml]="html | sanitizeHtml"></div>
<!-- rendering from templates end -->

<div class="panel-content">
  <div id="embed-view-1" *ngIf="!click">
    <div class="share-mode share-mode-type" style="border-top: 0px">
      <p class="padding-0"><strong>Embed Type</strong></p>
      <p class="m-inline font-size-13 padding-0">Basic Embed Interface</p>
      <input
        [checked]="true"
        type="radio"
        name="embedMode"
        #basicEmbed
        id="basicEmbed"
        [checked]="basicMode"
        (change)="basicModeType(basicEmbed.checked)"
      />
      <div class="share-mode">
        <p class="m-inline font-size-13 padding-0">TCPD Embed</p>
        <input
          type="radio"
          name="embedMode"
          #tcpdEmbedData
          id="tcpdEmbedData"
          [checked]="tcpdEmbed"
          (change)="tcpdEmbedType(tcpdEmbedData.checked)"
        />
      </div>
    </div>
    <div class="embed-opt" >
      <div class="share-mode">
        <p class="padding-0"><strong>Embed Options</strong></p>
        <p class="m-inline font-size-13 padding-0">Default Modal</p>
        <input
          type="checkbox"
          name="defaultModal"
          #defaultModalData
          id="defaultModalData"
          [checked]="defaultModal"
          (change)="defaultModalType(defaultModalData.checked)"
        />
      </div>
      <div class="share-mode">
        <p class="font-size-13 padding-0">Modal Template:</p>
        <input
          style="float: unset"
          [ngClass]="isModalInput? 'disableInput': ''"
          type="text"
          name="template"
          placeholder="{%template name%}"
          [(ngModel)]="modalTemplate"
          [disabled]="isModalInput"
          (change)="templateBox($event)"
        />
      </div>
      <div class="share-mode">
        <p class="m-inline font-size-13 padding-0">Require Checkbox</p>
        <input
          type="checkbox"
          name="requireCheckbox"
          id="requireCheckbox"
          [(ngModel)]="requireCheckbox"
          (change)="requireCheckBoxType(requireCheckbox)"
        />
      </div>
      <div class="share-mode">
        <p class="font-size-13 padding-0">Checkbox Template:</p>
        <input
          [ngClass]="isCheckboxInput? 'disableInput': ''"
          style="float: unset"
          type="text"
          name="checkboxTemplate"
          placeholder="{%template name%}"
          [(ngModel)]="checkboxTemplate"
          [disabled]="isCheckboxInput"
          (change)="boxTemplate($event)"
        />
      </div>
    </div>
    <div class="share-mode" style="border-bottom: 1px dotted black; margin-bottom: 20px;">
      <p class="m-inline font-size-13 padding-0">Privilege Level:</p>
      <select
        id="embedClient"
        (change)="layerSelect($event)"
        [(ngModel)]="selectedUser"
      >
        <option
          value="{{ data.privilegeLevel }}"
          *ngFor="let data of accessLevel"
        >
          {{ data.access }}
        </option>
      </select>
    </div>
    <div class="share-mode">
      <p class="padding-0"><strong>Duration</strong></p>
      <p class="m-inline font-size-13 padding-0">Expiry</p>
      <input
      [(ngModel)]="expiryValue"
        type="checkbox"
        name="expire_embed"
        id="embed_expiry"
        (change)="expiry($event)"
      />
    </div>
    <div class="share-mode">
      <input
        [(ngModel)]="date"
        type="date"
        name="expire_time"
        class="date_time_input"
        [disabled]="isReadOnly"
        (change)="changeDate($event)"
      />
      <p class="text-right" style="text-align: right">
        <small>Date and time in Pacific Time</small>
      </p>
    </div>
    <div class="button-container">
      <a
        (click)="createLink()"
        id="generate-embed-link"
        class="btn btn-default pull-right"
        title="Makes a hyperlink that opens to your current map view."
        >Create Link</a
      >
      <div style="clear: both"></div>
    </div>
  </div>
  <div id="embed-view-2" *ngIf="click">
    <p class="font-size-13">
      Copy this code and place on a website to create an embed.
    </p>
    <p class="font-size-13">
      Link can also be used as a standard Live Share with augmented features.
    </p>
    <div id="embed-iframe-area">
      <a
        id="copy-to-clipboard"
        class="btn-primary"
        data-copytarget="#share-iframe"
        style="padding-bottom: 6px; margin-left: 0px"
        title="Copies hyperlink to clipboard automatically."
        (click)="copy(inputElement)"
        >Copy</a
      ><textarea
        id="share-iframe"
        [(ngModel)]="linkData"
        #inputElement
        readonly
        >{{ linkData }}</textarea
      >
    </div>
    <div id="embed-frame-height">
      <p class="panel-text">Adjust iframe px height:</p>
      <input
        class="m-inline"
        id="frame-height"
        type="number"
        min="0"
        step="1"
        [(ngModel)]="height"
      /><a
        id="update-frame-height"
        class="btn-primary m-inline"
        title="Change iFrame height"
        (click)="updateHeight()"
        >Update</a
      >
    </div>
    <div id="embed-url-area" class="dotted-border">
      <p class="panel-text" style="padding: 0px">
        Copy this link to share as a Live Share with augmented features.
      </p>
      <input
        #inputElement1
        type="text"
        class="m-inline"
        id="embed-url"
        value="{{ tinyurl }}"
        readonly=""
      /><a
        id="copy-to-clipboard"
        style="
          padding-bottom: 6.5px;
          padding-top: 5px;
          float: right;
          margin-top: 6%;
        "
        class="btn-primary"
        data-copytarget="#embed-url"
        title="Copies hyperlink to clipboard automatically."
        (click)="copy(inputElement1)"
        >Copy</a
      >
    </div>
    <div class="button-container">
      <a
        id="start-over"
        class="btn btn-default pull-right"
        title="Create a new link"
        (click)="startOver()"
        >Start Over</a
      >
      <div style="clear: both"></div>
    </div>
  </div>
</div>
<div class="buttonDiv">
  <a class="closer closerToolTip" >
    <img
    (click)="closeLeft()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span
    class="tooltiptext tip-bottom"
    [innerHtml]="mapService.templatetoolTips['close_left_panel']"
  ></span>
  </a>
</div>
